document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const sections = document.querySelectorAll('[class*="shopify-section"]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('shown-visible');
        } 
        // else {
        //   entry.target.classList.remove('shown-visible'); // optional
        // }
      });
    }, {
      threshold: 0.2
    });

    sections.forEach(section => observer.observe(section));
  }, 1); // small delay lets CSS and layout settle
});

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header-component');
  if (!header) return;

  const row = header.querySelector('.header__row');
  if (!row) return;

  // Detect touch support
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // ✅ Desktop hover behavior
  if (!isTouch) {
    header.addEventListener('mouseenter', () => {
      header.classList.add('is_active');
      row.classList.add('header-active');
    });

    header.addEventListener('mouseleave', () => {
      header.classList.remove('is_active');

      if (header.getAttribute('data-scroll-direction') === 'up') {
        row.classList.add('header-active');
      } else {
        row.classList.remove('header-active');
      }
    });
  }

  // ✅ Scroll direction tracking (works on both desktop & mobile)
  const observer = new MutationObserver(() => {
    if (header.getAttribute('data-scroll-direction') === 'up') {
      row.classList.add('header-active');
    } else {
      row.classList.remove('header-active');
    }
  });

  observer.observe(header, {
    attributes: true,
    attributeFilter: ['data-scroll-direction']
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('slideshow-slide');
  if (!slides.length) return;

  let navClick = false;

  // Detect arrows/dots clicks
  const arrowButtons = document.querySelectorAll('slideshow-arrows button');
  const dotButtons = document.querySelectorAll('.slideshow-controls__dots button');
  [...arrowButtons, ...dotButtons].forEach(btn => {
    btn.addEventListener('click', () => { navClick = true; });
  });

  function animateSlide(slide) {
    const img = slide.querySelector('img');
    const content = slide.querySelector('.slide__content');

    img?.classList.add('slide-visible');

    if (content) {
      content.classList.add('slide-visible');
      Array.from(content.children).forEach((child, i) => {
        child.style.transitionDelay = `${i * 120}ms`;
        child.classList.add('slide-visible');
      });
    }
  }

  function resetSlide(slide) {
    const img = slide.querySelector('img');
    const content = slide.querySelector('.slide__content');

    img?.classList.remove('slide-visible');

    if (content) {
      content.classList.remove('slide-visible');
      Array.from(content.children).forEach((child) => {
        child.classList.remove('slide-visible');
        child.style.transitionDelay = '';
      });
    }
  }

  // 1️⃣ IntersectionObserver for drag/swipe
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const slide = entry.target;

      if (!navClick) {
        // Only animate fully visible slide
        if (entry.intersectionRatio >= 1) {
          animateSlide(slide);
        }
        // Do NOT reset the slide until the NEXT slide is fully visible
        // So we remove resetSlide() here for drag
      }
    });
  }, { threshold: [1] });

  slides.forEach(slide => observer.observe(slide));

  // 2️⃣ MutationObserver for arrows/dots
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'aria-hidden') {
        const slide = mutation.target;

        if (slide.getAttribute('aria-hidden') === 'false' && navClick) {
          // Animate after 0.5s delay
          setTimeout(() => {
            animateSlide(slide);
            navClick = false;
          }, 50);
        } else if (slide.getAttribute('aria-hidden') === 'true') {
          // Reset slide only when fully hidden
          resetSlide(slide);
        }
      }
    });
  });

  slides.forEach(slide => mutationObserver.observe(slide, { attributes: true }));
});


document.addEventListener('DOMContentLoaded', () => {
    const headerComponent = document.getElementById('header-component');
    const slideshowSlides = document.querySelector('slideshow-slides[size="slideshow_full_height"]');

    if (!headerComponent || !slideshowSlides) {
        console.error("Header or Slideshow element not found.");
        return;
    }

    function updateSlideshowHeight() {
        // This checks if the attribute is present AND equal to 'not-sticky'
        const isNotStickyTransparent = headerComponent.getAttribute('transparent') === 'not-sticky';

        if (isNotStickyTransparent) {
            // If the attribute IS present and equals 'not-sticky', stop execution 
            // and optionally reset height. The calculation is SKIPPED.
            slideshowSlides.style.height = ''; 
            console.log("Slideshow height reset (transparent='not-sticky' is present).");
            return; 
        }
        
        // **The code below only runs if the attribute IS NOT present or has a different value.**

        // 1. Check screen width and select viewport unit
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const viewportUnit = isMobile ? 'svh' : 'dvh'; 

        // 2. Measure the actual height of the header component
        const headerHeight = headerComponent.getBoundingClientRect().height;

        // 3. Calculate and apply the dynamic height
        const newHeight = `calc(100${viewportUnit} - ${headerHeight}px)`;
        slideshowSlides.style.height = newHeight;
        
        console.log(`Header Height: ${headerHeight}px. Setting slideshow height to: ${newHeight}`);
    }

    // Run on load
    updateSlideshowHeight();

    // Run on window resize
    window.addEventListener('resize', updateSlideshowHeight);
});
